export default ({
  FIRST_TIME: '@isFirstTime',
  ACCESS_TOKEN: 'accessToken',
});
